module.exports = __webpack_public_path__ + "assets/4eb69fe2abe06aedd005fe8d30a5dcf5.mp3";